import ModuleMultiCoulumnvidoes from "./ModuleMultiCoulumnvidoes";

export default ModuleMultiCoulumnvidoes;